import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'recrewt-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SectionComponent {
  readonly active = input(false);

  readonly title = input('Title.');

  readonly sectionClicked = output<void>();

  onSectionClicked(): void {
    this.sectionClicked.emit();
  }
}
